import { observer } from 'mobx-react';
import { useEffect, useRef } from 'react';
import { useStores } from '../mobx/storeContext';
import { ENV_BASED_CONFIG, WS_BASE_URL } from '../utils/constants';

const HEARTBEAT_INTERVAL = 30000; // 30 seconds
const RECONNECT_INTERVAL = 3000; // 3 seconds

const PriceFetcherUpdateListener = observer(() => {
  const { priceFetcherUpdateStore } = useStores();
  const reconnectTimeoutRef = useRef(null);
  const heartbeatIntervalRef = useRef(null);

  const setupHeartbeat = (socket) => {
    // Clear any existing heartbeat
    if (heartbeatIntervalRef.current) {
      clearInterval(heartbeatIntervalRef.current);
    }

    // Set up a new heartbeat
    heartbeatIntervalRef.current = setInterval(() => {
      if (socket.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify({ type: 'ping' }));
      }
    }, HEARTBEAT_INTERVAL);
  };

  const connectWebSocket = (pid) => {
    const subCompanyId = ENV_BASED_CONFIG.subCompanyId;
    const uri = `${WS_BASE_URL}/conversion_ws?projectID=${pid}&sub_company_id=${subCompanyId}&awefjawlefkjawlekfjawlegkja=awekfjawekfhaewlfjasldvmorbjaewof`;
    const socket = new WebSocket(uri);
    socket.onopen = () => {
      if (reconnectTimeoutRef.current) {
        clearTimeout(reconnectTimeoutRef.current);
        reconnectTimeoutRef.current = null;
      }
      setupHeartbeat(socket);
      // 交條 socket 畀個 store，等「計算」掣送得到變數上去（斷線重連亦會自動補送返）。
      priceFetcherUpdateStore.setSocket(socket);
    };

    socket.onmessage = (e) => {
      const data = e.data;
      try {
        // Parse the message if it's JSON
        const parsedData = typeof data === 'string' ? JSON.parse(data) : data;
        // Handle pong response (server heartbeat response)
        if (parsedData.type === 'pong') {
          return;
        }
        // Process regular messages
        priceFetcherUpdateStore.setData(parsedData);
      } catch (error) {
        console.log('error', error);
        // Handle non-JSON messages
      }
    };

    socket.onerror = (error) => {
      console.error('WebSocket error:', error);
    };

    socket.onclose = (event) => {
      console.log(`WebSocket connection closed. Code: ${event.code}, Reason: ${event.reason}`);
      priceFetcherUpdateStore.setSocket(null);
      // Clean up heartbeat
      if (heartbeatIntervalRef.current) {
        clearInterval(heartbeatIntervalRef.current);
      }

      // Attempt to reconnect
      reconnectTimeoutRef.current = setTimeout(() => connectWebSocket(priceFetcherUpdateStore.pid), RECONNECT_INTERVAL);
    };

    return socket;
  };
  useEffect(() => {
    const socket = connectWebSocket(priceFetcherUpdateStore.pid);

    return () => {
      if (heartbeatIntervalRef.current) {
        clearInterval(heartbeatIntervalRef.current);
      }

      if (reconnectTimeoutRef.current) {
        clearTimeout(reconnectTimeoutRef.current);
      }

      if (socket) {
        socket.close();
      }
    };
  }, [priceFetcherUpdateStore.refreshPidKey]);

  return null;
});

export default PriceFetcherUpdateListener;
